import React from "react";

interface LabelProps {
  position?: "left" | "center" | "right";
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "12px" | "14px" | "16px";
  fontWeight?: "semibold" | "bold";
  text: string | undefined | number | any | [];
  paddingTop?: number;
  className?: string;
}
const Label = ({
  position,
  size,
  fontWeight,
  text,
  paddingTop,
  className,
}: LabelProps) => {
  const textSize =
    size === "sm"
      ? "text-sm"
      : size === "md"
      ? "text-md"
      : size === "lg"
      ? "text-lg"
      : size === "xl"
      ? "text-xl"
      : size === "2xl"
      ? "text-2xl"
      : size === "3xl"
      ? "text-3xl"
      : size === "12px"
      ? "text-custom-micro"
      : size === "14px"
      ? "text-custom-petite"
      : size === "16px"
      ? "text-custom-standard"
      : "text-md";
  return (
    <label
      className={`text-${position} font-${fontWeight} transition-colors duration-300 ease-in-out ${className}`}
      style={{ paddingTop: paddingTop }}
    >
      {text}
    </label>
  );
};

export default Label;
